import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { MaterialModule } from '../material/material.module'
import { UploaderModule } from './uploader/uploader.module'

import { IconComponent } from './icon/icon.component'
import { NavComponent } from './nav/nav.component'
import { LauncherComponent } from './launcher/launcher.component'
import { SidemenuComponent } from './sidemenu/sidemenu.component'
import { ModalComponent } from './modal/modal.component'
import { SpinnerComponent } from './spinner/spinner.component'
import { SearchFieldComponent } from './search-field/search-field.component'

import { DialogsService } from './dialog/dialogs.service'
import { DialogComponent } from './dialog/dialog/dialog.component'
import { AlertComponent } from './dialog/dialogs/alert/alert.component'
import { ConfirmComponent } from './dialog/dialogs/confirm/confirm.component'
import { GenericComponent } from './dialog/dialogs/generic/generic.component'
import { LoadingComponent } from './dialog/dialogs/loading/loading.component';
import { WallComponent } from './wall/wall.component';
import { MotiveComponent } from './motive/motive.component'
import { MotiveService } from './motive/motive.service';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { WarningComponent } from './dialog/dialogs/warning/warning.component';
import {ConfirmRevertComponent} from './dialog/dialogs/confirm-revert/confirm-revert.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  declarations: [
    IconComponent,
    LauncherComponent,
    NavComponent,
    SidemenuComponent,
    ModalComponent,
    SpinnerComponent,
    SearchFieldComponent,

    DialogComponent,
    AlertComponent,
    ConfirmComponent,
      ConfirmRevertComponent,
    GenericComponent,
    LoadingComponent,

    WallComponent,
    MotiveComponent,
    BreadcrumbComponent,
    WarningComponent,
  ],
  entryComponents: [
    DialogComponent,
    AlertComponent,
    ConfirmComponent,
      ConfirmRevertComponent,
    LoadingComponent,
    MotiveComponent,
    WarningComponent
  ],
    exports: [
        IconComponent,
        LauncherComponent,
        NavComponent,
        SidemenuComponent,
        ModalComponent,
        SpinnerComponent,
        SearchFieldComponent,

        DialogComponent,
        AlertComponent,
        ConfirmComponent,
        ConfirmRevertComponent,
        GenericComponent,
        LoadingComponent,

        WallComponent,

        UploaderModule,
        ReactiveFormsModule,
        FormsModule,
        BreadcrumbComponent,
        WarningComponent
    ],
  providers: [
    DialogsService,
    MotiveService
  ]
})
export class ComponentsModule { }
